import { render, staticRenderFns } from "./suspensionBar.vue?vue&type=template&id=a36278d6&scoped=true&"
import script from "./suspensionBar.vue?vue&type=script&lang=ts&"
export * from "./suspensionBar.vue?vue&type=script&lang=ts&"
import style0 from "./suspensionBar.vue?vue&type=style&index=0&id=a36278d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36278d6",
  null
  
)

export default component.exports